import { useEffect } from "react";

export function useDocumentMeta({
  title,
  description,
  robots = "index,follow,max-image-preview:large",
  canonical,
}: {
  title: string;
  description: string;
  robots?: string;
  canonical: string;
}) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("robots", robots);
    setProperty("og:title", title);
    setProperty("og:description", description);
    setProperty("og:url", canonical);
    const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (link) link.href = canonical;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [canonical, description, robots, title]);
}

function setMeta(name: string, content: string) {
  const element = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (element) element.content = content;
}

function setProperty(property: string, content: string) {
  const element = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (element) element.content = content;
}
